import "./SampleDocCard.css";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";

import { Button, Card, Image, Space, Tooltip, Typography } from "antd";
import PropTypes from "prop-types";

const SampleDocCard = ({
  title,
  fileUrl,
  description,
  modeUsed,
  updateFileContent,
  handleSubmit,
  modeId,
  selectedDoc,
  thumbnail,
  verticalLine,
  horizontalLine,
}) => {
  const { Title, Text } = Typography;

  return (
    <Card className="document-card" bordered>
      <div className="document-card-header">
        <Tooltip title={title}>
          <Title level={5} className="document-card-title">
            {title}
          </Title>
        </Tooltip>
      </div>
      <div className="pdf-thumbnail-container">
        <Space direction="vertical">
          <Image
            className="select-doc-thumbnail"
            src={thumbnail}
            height={180}
            width={180}
            preview={false}
            onClick={() => updateFileContent(fileUrl)}
          />
        </Space>
      </div>
      {selectedDoc?.file === fileUrl && selectedDoc?.mode === modeId}
      <Button
        className="sample-doc-result-button"
        type="primary"
        onClick={() =>
          handleSubmit(
            fileUrl,
            {
              mode: modeId,
              verticalLine: verticalLine,
              horizontalLine: horizontalLine,
            },
            title
          )
        }
      >
        See Results
      </Button>
      <Text className="document-card-description">{description}</Text>
      <div className="document-card-mode-used-container">
        <Text className="document-card-mode-used">
          <strong>Mode used:</strong> {modeUsed}
        </Text>
      </div>
    </Card>
  );
};

SampleDocCard.propTypes = {
  title: PropTypes.string.isRequired,
  fileUrl: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  modeUsed: PropTypes.string.isRequired,
  updateFileContent: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  modeId: PropTypes.string.isRequired,
  selectedDoc: PropTypes.object.isRequired,
  thumbnail: PropTypes.any,
  id: PropTypes.string.isRequired,
  verticalLine: PropTypes.bool.isRequired,
  horizontalLine: PropTypes.bool.isRequired,
};

export { SampleDocCard };
